import React, { useEffect } from 'react';
import { useTrainingStore } from '../stores/useTrainingStore';

const WorkoutSyncMonitor: React.FC = () => {
  const sessionId = useTrainingStore(state => state.sessionId);
  const setSyncStatus = useTrainingStore(state => state.setSyncStatus);

  useEffect(() => {
    const markOnline = () => {
      setSyncStatus(sessionId ? 'syncing' : 'synced');
      window.setTimeout(() => setSyncStatus('synced'), 1200);
    };
    const markOffline = () => setSyncStatus(sessionId ? 'local' : 'offline');

    window.addEventListener('online', markOnline);
    window.addEventListener('offline', markOffline);

    return () => {
      window.removeEventListener('online', markOnline);
      window.removeEventListener('offline', markOffline);
    };
  }, [sessionId, setSyncStatus]);

  return null;
};

export default WorkoutSyncMonitor;
